import React from 'react';
import MaxWidth from '../Layout/MaxWidth';
import { styled } from 'linaria/react';
import { LinkButton } from '../ui/Button';
import { Above, Below } from '@jetshop/ui/Breakpoints';
import { theme } from '../Theme';

export const SubCategories = styled('div')`
  margin: 0 auto;
  padding: 1.625rem 0;
  ul {
    margin: 0 -0.8125rem -1.625rem;
    text-align: center;
    li {
      margin: 0 0.8125rem 1.625rem;
      display: inline-block;
    }
  }
  ${theme.below.md} {
    max-width: 100%;
    padding: 0;
    ul {
      padding: 1rem 0;
      overflow-x: auto;
      white-space: nowrap;
      margin: 0;
      li {
        margin: 0 0.25rem;
        &:first-of-type {
          margin-left: 1rem;
        }
        &:last-of-type {
          margin-right: 1rem;
        }
      }
    }
  }
`;

const Wrapper = ({ children }) => (
  <>
    <Above breakpoint="md">
      <MaxWidth>{children}</MaxWidth>
    </Above>
    <Below breakpoint="md">{children}</Below>
  </>
);

const SubcategoriesButtons = ({ hasSubcategories, subcategories }) => {
  if (!hasSubcategories) return null;

  return (
    <Wrapper>
      <SubCategories>
        <ul>
          {subcategories.map(cat => (
            <li key={cat.id}>
              <LinkButton className="small" to={cat.primaryRoute.path}>
                {cat.name}
              </LinkButton>
            </li>
          ))}
        </ul>
      </SubCategories>
    </Wrapper>
  );
};

export default SubcategoriesButtons;
